import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useApplication } from '../../AppContext';

const FindMatch = ({ room, setRoom }) => {
	const { t } = useTranslation();

	const app = useApplication();

	React.useEffect(() => {

		(async () => {
			const room = await app.multiplayer.joinPublicGame({
				playerName: app?.userdata?.name,
				name: app?.userdata?.name,
				avatar: app?.userdata?.avatar,
			});

			if (room) {
				setRoom(room);
			}
		})();
	}, [app, setRoom]);

	const content = React.useMemo(() => {
		if (!room) {
			return (
				<>{t('Looking')}...</>
			);
		}

		return null;
	}, [room, t]);
	return (
		content
	);
};

export default React.memo(FindMatch);
